export enum TipoPreguntaEncuestaSatisfaccionEnum{
    Abierta = 1,
    Checkbox = 2,
    Seleccion_Multiple = 3,
    Emoji = 4
}